<section class="upload-input">
  @if (showDownloads) {
  <h3 class="upload-section">{{ customLabel }}</h3>
  }
  <div ngxDragNDrop (fileDropped)="startUploading($event)" (uploadStatus)="changeStatus($event)">
    <input type="file" #uploadInput style="display: none" (change)="startUploading($event)" multiple accept="image/png, image/jpeg, application/pdf" />
    <div #uploadContainer class="upload-container tw-bg-white dark:tw-bg-gray-800">
      <ng-container *ngIf="!files.length && !uploadedFiles.length">
        <div class="upload-state" (click)="uploadFile()">
          <img src="https://library.micetribe.com/icons/upload.svg" alt="upload" />
          <img src="https://library.micetribe.com/icons/input-selected.svg" alt="upload" />
          <img src="https://library.micetribe.com/icons/upload-selected.svg" alt="upload" />
          @if (label) {
          <p class="upload-label tw-text-center tw-text-sm tw-text-gray-500 tw-my-1 tw-font-inter">{{ label }}</p>
          }
          <p class="action">{{ uploadStatus }}</p>
          <p class="info tw-text-center" [innerHTML]="getFormattedHelpText()"></p>
        </div>
      </ng-container>
      <ng-container *ngIf="files.length || uploadedFiles.length">
        <ng-container *ngIf="uploadedFiles.length < 7 && !isDeleting">
          <div class="preview-files-state d-flex align-items-center" [ngStyle]="uploadedFiles.length === 6 ? { 'justify-content': 'space-between' } : {}">
            <div class="upload-more-btn h-100" (click)="uploadFile()">
              <div class="download w-100 h-100 d-flex align-items-center justify-content-center">
                <mat-icon>add</mat-icon>
              </div>
            </div>
            <div class="downloads d-flex" *ngFor="let uploadedFile of uploadedFiles; let i = index">
              <div class="download d-flex justify-content-center" [title]="uploadedFile.display_name">
                <img [src]="uploadedFile.encoded_url" [alt]="uploadedFile.display_name" *ngIf="uploadedFile.extension !== 'pdf'" />
                <p *ngIf="uploadedFile.extension === 'pdf'">PDF</p>
                <button type="button" class="close-btn" (click)="showDeleteModal(i, uploadedFile.id, uploadedFile)" aria-label="Remove file">
                  <mat-icon>close</mat-icon>
                </button>
                <div class="download-link-container">
                  <span
                    #fileName
                    class="download-link"
                    contenteditable
                    (click)="selectFileName($event)"
                    (keydown.enter)="$event.preventDefault(); fileName.blur()"
                    (focus)="selectFileName($event)"
                    (blur)="editFileName($event, uploadedFile, i)"
                  >
                    {{ uploadedFile.display_name }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="uploadedFiles.length >= 7 && !isDeleting">
          <div class="upload-carousel position-relative">
            <owl-carousel-o [options]="customOptions">
              <ng-template carouselSlide>
                <div class="upload-more-btn h-100" (click)="uploadFile()">
                  <div class="download w-100 h-100 d-flex align-items-center justify-content-center">
                    <mat-icon>add</mat-icon>
                  </div>
                </div>
              </ng-template>
              <ng-template *ngFor="let uploadedFile of uploadedFiles; let i = index" carouselSlide>
                <div class="downloads">
                  <div class="download d-flex flex-column justify-content-center" [title]="uploadedFile.display_name">
                    <img [src]="uploadedFile.encoded_url" [alt]="uploadedFile.display_name" *ngIf="uploadedFile.extension !== 'pdf'" />
                    <p *ngIf="uploadedFile.extension === 'pdf'">PDF</p>
                    <button type="button" class="close-btn" (click)="showDeleteModal(i, uploadedFile.id, uploadedFile)" aria-label="Remove file">
                      <mat-icon>close</mat-icon>
                    </button>
                    <div class="download-link-container">
                      <span
                        #fileName
                        class="download-link"
                        contenteditable
                        (click)="selectFileName($event)"
                        (keydown.enter)="$event.preventDefault(); fileName.blur()"
                        (focus)="selectFileName($event)"
                        (blur)="editFileName($event, uploadedFile, i)"
                      >
                        {{ uploadedFile.display_name }}
                      </span>
                    </div>
                  </div>
                </div>
              </ng-template>
            </owl-carousel-o>
          </div>
        </ng-container>
        <ng-container *ngIf="isDeleting">
          <div class="delete-container d-flex">
            <div class="delete-container__delete-text">
              <p>Delete {{ deleteFileName }}</p>
            </div>
            <div class="delete-container__button-container d-flex justify-content-center">
              <button class="cancel-button mr-3" (click)="isDeleting = false">Cancel</button>
              <button class="delete-button" (click)="deleteUploadedFile()">Delete</button>
            </div>
          </div>
        </ng-container>
        <div class="loading-container" [ngStyle]="uploadedFiles.length >= 7 && !isDeleting ? { padding: '0 30px 10px' } : {}">
          <div class="loading-state d-flex flex-column tw-overflow-hidden" *ngFor="let singleFile of files">
            <div class="d-flex justify-content-between">
              <div class="d-flex flex-column gap-0">
                <p class="file-name m-0 dark:tw-text-gray-500 tw-text-black">{{ singleFile.file.name }}</p>
                <span class="file-size dark:tw-text-gray-500 tw-text-black">{{ singleFile.file.size | fileSize : 2 }}</span>
              </div>
              <button mat-icon-button class="delete-btn" (click)="cancelUpload(singleFile.id)">
                <img src="https://library.micetribe.com/icons/delete-outline.svg" alt="delete-icon" />
              </button>
            </div>
            <div class="progress-bar-container d-flex flex-row justify-content-between align-items-center">
              <mat-progress-bar mode="determinate" [value]="singleFile.progress" [color]="singleFile.state"></mat-progress-bar>
              <span class="progress-percentage">{{ singleFile.progress }}%</span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
